import { useCallback, useEffect, useState } from 'react';
import styles from './spacesOfAttribute.module.scss';
import {
  AdRequestSourceManager,
  DefaultAdRequestSourceManager
} from 'core/adRequestSource/AdRequestSourceManager';
import { LoadingCircle } from 'components/LoadingCircle/LoadingCircle';
import { useCallAPI } from 'hooks/useCallAPI';
import { DefaultChannelGroupManager } from 'core/channelGroup/ChannelGroupManager';

type SpacesOfSynchronizedPlaybackGroupProps = {
  groupId: string;
  channelGroupId: number;
  // POS-8073：測試模式下要查 TESTING 版位。沒帶的話 BE 兩支都預設只回 ON，
  // 而測試模式的群組底下只有 TESTING 版位 ⇒ tooltip 會渲染成空清單。
  testMode?: boolean;
};

const adRequestSourceManager: AdRequestSourceManager =
  new DefaultAdRequestSourceManager();
const channelGroupManager = new DefaultChannelGroupManager();

export const SpacesOfSynchronizedPlaybackGroup: React.FC<
  SpacesOfSynchronizedPlaybackGroupProps
> = ({ groupId, channelGroupId, testMode }) => {
  const [spaces, setSpaces] = useState<SelectOptions[]>();
  const { callAPIs } = useCallAPI();

  useEffect(() => {
    (async () => {
      callAPIs(
        [
          () =>
            channelGroupManager.getSpaceIdsOfSimulcastGroup(groupId, testMode)
        ],
        (spaceIds: string[]) => {
          callAPIs(
            [
              () =>
                adRequestSourceManager.getSpacesWithConditions(
                  false,
                  { spaceId: spaceIds },
                  'Outdoor',
                  channelGroupId,
                  undefined,
                  testMode
                )
            ],
            setSpaces
          );
        }
      );
    })();
  }, [groupId, channelGroupId, testMode, callAPIs]);

  const renderSpaces = useCallback((spaces: SelectOptions[]) => {
    const items = spaces.map((space) => (
      <li key={space.value}>
        <div>{space.label}</div>
      </li>
    ));
    return <ul>{items}</ul>;
  }, []);

  return (
    <div className={styles.spacesOfAttribute}>
      {spaces ? renderSpaces(spaces) : <LoadingCircle width={15} height={15} />}
    </div>
  );
};

export const renderSpacesOfSynchronizedPlaybackGroup = (
  groupId: string,
  channelGroupId: number,
  testMode?: boolean
) => {
  return (
    <SpacesOfSynchronizedPlaybackGroup
      groupId={groupId}
      channelGroupId={channelGroupId}
      testMode={testMode}
    />
  );
};
